import { MeasuringConceptsFormStepContent } from '@/api/interfaces/content/form/steps/measuringConceptsFormStepContent';

export const measuringConceptsContent: MeasuringConceptsFormStepContent = {
    stepHeading: 'Messkonzepte',
    buttonNext: {
        text: 'Weiter',
    },
    fullInfeedBonusHeadline: {
        text: '<strong>Volleinspeisebonus</strong>',
    },
    operatingMode: {
        label: 'Betriebsweise',
        placeholder: 'Bitte wählen',
        options: {
            fullInfeed: {
                label: 'Volleinspeisung',
            },
            surplusInfeed: {
                label: 'Überschusseinspeisung',
            },
            zeroInfeed: {
                label:
                    'Nulleinspeisung (Speicher und keine Einspeisung in das öffentliche Netz)',
            },
            commercialTransfer: {
                label: 'kaufmännisch-bilanzielle Weitergabe',
            },
        },
    },
    fullInfeedBonus: {
        label:
            'Ich beanspruche / wir beanspruchen den erhöhten anzulegenden Wert gemäß § 48 Abs. 2a EEG (Erhöhung des anzulegenden Werts bei Volleinspeisung). Ich teile/ wir teilen Ihnen hiermit mit, dass ich/ wir den gesamten im Kalenderjahr in meiner/ unserer Anlage erzeugten Strom mit Ausnahme des Stroms, der in der Solaranlage oder in deren Neben- und Hilfsanlagen zur Erzeugung von Strom im technischen Sinn verbraucht wird, nach § 48 Abs. 2a EEG in das Netz von EWE NETZ einspeisen werde(n).&nbsp;<br />\r\nMir/ uns ist bekannt, dass bei Verletzung der Anforderungen gem. § 52 Abs. 1 Nr. 10 EEG Zahlungen zu leisten sind.',
    },
    measuringPointOperatorInfo: {
        text:
            'Um in Engpasssituationen im Stromnetz die Leistung ihres Gerätes zu begrenzen, ist der Einbau von Steuerungstechnik notwendig. Hierfür haben Sie als Betreiber dafür Sorge zu tragen, dass die Anlage im Rahmen der in den technischen Anschlussbedingungen Niederspannung (Strom) des Netzbetreibers vorgegebenen möglichen Steuerungstechniken einschließlich Steuerungseinrichtungen ausgestattet wird, stets steuerbar ist und ein vom Netzbetreiber ausgegebener Steuerbefehl unverzüglich umgesetzt wird. Den Einbau von Steuerungstechnik übernimmt Ihr Messstellenbetreiber',
    },
    measuringPointOperation: {
        label: 'Der Messstellenbetrieb soll erfolgen durch',
        info:
            'Nach dem Messstellenbetriebsgesetz (MsbG) ist EWE NETZ als grundzust&auml;ndiger Messstellenbetreiber verpflichtet, moderne Messeinrichtungen (Anlagenleistung bis 7 KW) und intelligente Messsysteme (Anlagenleistung gr&ouml;&szlig;er 7 KW) einzubauen. Sobald die technische Verf&uuml;gbarkeit nach &sect; 30 MsbG gegeben ist, werden wir Ihre Anlagen mit der neuen Technik ausstatten. Weitere Informationen finden Sie unter <a rel="noopener noreferrer" rel="noopener noreferrer" href="http://www.ewe-netz.de" target="_blank">www.ewe-netz.de</a>.',
        options: {
            ewe: {
                label: 'EWE NETZ Messeinrichtung für Einspeisung',
            },
            other: {
                label:
                    'einen anderen Messstellenbetreiber gemäß § 10 Abs. 1 EEG (MSB-ID)E',
            },
        },
    },
    measuringPointOperator: {
        label: 'Messstellenbetreiber',
        placeholder: 'Bitte wählen',
        search: {
            placeholder: 'Filter',
            noResults: 'Keine Ergebnisse',
        },
    },
    storageHeadline: {
        text: 'Speicher (Batterie)',
    },
    measuringPointOperationInfoEwe: {
        text:
            '<span class="font-bold">Bedingungen zur Herstellung Steuerbarkeit</span><br /><br />F&uuml;r die Herstellung der Steuerbarkeit von steuerbaren Verbrauchseinrichtungen nach &sect; 14a EnWG bzw. von Speichern und Erzeugungsanlagen nach &sect;9 EEG wird am Netzanschlusspunkt eine Steuerungseinrichtung installiert. Diese Installation ist eine gesetzliche Standardleistung des Messstellenbetreibers. &sect; 34 Abs. 1 Nr. 5 MsbG legt fest, dass der Einbau, der Betrieb sowie die IT‐Anbindung und Konfiguration der Steuerungseinrichtung zu den Standardleistungen geh&ouml;ren. Die Kosten dieser Standardleistung werden dem Anschlussnehmer (in der Regel dem Grundst&uuml;ckseigent&uuml;mer) in Rechnung gestellt. Weitere Details ergeben sich aus dem <a rel="noopener noreferrer" href="https://www.ewe-netz.de/-/media/ewe-netz/downloads/2026_03_10_messstellenvertrag-strom-mme-und-ims_stand-2026_03_01.pdf" target="_blank">Messstellenvertrag Strom</a> und den <a rel="noopener noreferrer" href="https://www.ewe-netz.de/-/media/ewe-netz/downloads/2026_03_10_ewe_netz_preise_gmsb_ab_01-01-26.pdf" target="_blank">Preisen f&uuml;r den Messtellenbetrieb</a>.<br /><br />Sie sind nicht der Anschlussnehmer bzw. Eigent&uuml;mer? Dann k&ouml;nnen Sie im weiteren Verlauf der Anmeldung die Daten des Eigent&uuml;mers eingeben.',
    },
    measuringPointOperationInfoOther: {
        text:
            '<p class="font-bold">Hinweis</p>\r\n<p>Bitte beauftragen Sie Ihren Messstellenbetreiber mit dem Einbau der Steuerungstechnik separat, die Beauftragung erfolgt nicht über dieses Portal.</p>',
    },
    priceSheetMeasuringPointOperation: {
        text:
            'Preisblatt Messstellenbetrieb EWE NETZ&nbsp;<a href="https://local.deaapi.ewe-netz.de/-/media/dea/dokumente/formular/preisblatt-msb.pdf" target="_blank">herunterladen</a>',
    },
    specialSupplyConcept: {
        label:
            'Ich m&ouml;chte ein besonderes Versorgungskonzept (Mieterstrom oder gemeinschaftliche Geb&auml;udeversorgung nach &sect; 42b EnWG) umsetzen und ben&ouml;tige daher ein spezielles Messkonzept.',
        info:
            'Von einem besonderen Versorgungskonzept sprechen wir, wenn Sie den Strom aus Ihrer Anlage nicht nur selbst verbrauchen oder ins Netz einspeisen, sondern auch an weitere Kunden liefern m&ouml;chten.',
    },
    specialSupplyConceptInfo: {
        text:
            '<ul class="list-disc pl-4"><li>Im Vergleich zur klassischen EEG-Einspeisung sind diese Versorgungskonzepte f&uuml;r Sie deutlich aufwendiger umzusetzen. Zun&auml;chst m&uuml;ssen die jeweiligen rechtlichen Anforderungen erf&uuml;llt werden. Zus&auml;tzlich werden Sie durch ein solches Modell faktisch zum Energieversorger und &uuml;bernehmen damit zahlreiche neue Aufgaben und Verpflichtungen.</li><li>Dazu geh&ouml;ren unter anderem die Abf&uuml;hrung von Umsatzsteuer und gegebenenfalls Energiesteuer f&uuml;r den gelieferten Strom, die umfassende Organisation und Verwaltung der Messdaten, eine rechtssichere Stromabrechnung sowie der Abschluss und die Abwicklung passender Energieliefervertr&auml;ge mit Ihren Kunden. Jeder Ihrer Kunden hat das Recht, Ihren Stromliefervertrag abzulehnen und seinen Energiebedarf vollst&auml;ndig &uuml;ber einen alternativen Energielieferanten aus dem Energieversorgungsnetz zu decken. Dies kann negative Auswirkungen auf Ihre Rentabilit&auml;t haben.</li><li>Zuletzt sind bei diesen Konzepten h&auml;ufig zus&auml;tzliche oder teurere Messungen bei Ihren Kunden erforderlich. Wer die daraus entstehenden Mehrkosten tr&auml;gt, sollten Sie unbedingt vorab klar mit Ihren Kunden vereinbaren.</li><li>In der Praxis zeigt sich immer wieder, dass Anlagenbetreiber diesen zus&auml;tzlichen Aufwand untersch&auml;tzen. Nicht selten muss das besondere Versorgungskonzept sp&auml;ter mit erheblichem finanziellem Aufwand f&uuml;r den Anlagenbetreiber wieder auf ein Standardmodell nach EEG zur&uuml;ckgef&uuml;hrt werden.</li></ul>',
    },
    specialSupplyConceptAcknowledgement: {
        label:
            'Ich bin mir der rechtlichen und kommerziellen Risiken vollst&auml;ndig bewusst und habe die Hinweise zur Kenntnis genommen.',
    },
    supplyConceptType: {
        label: 'Art des Versorgungskonzeptes',
        options: {
            tenantElectricity: {
                label:
                    'Ich m&ouml;chte als Energieversorger ein Mieterstrommodell umsetzen.',
            },
            communalBuildingSupply: {
                label:
                    'Ich m&ouml;chte als Energieversorger eine gemeinschaftliche Geb&auml;udeversorgung umsetzen.',
            },
        },
    },
    transferMeterType: {
        label: 'Gew&uuml;nschte Umsetzung des &Uuml;bergabez&auml;hlers',
        options: {
            virtualSummaryMeter: {
                label:
                    'Die &Uuml;bergabemessung in das Energieversorgungsnetz soll als virtueller Summenz&auml;hler ausgef&uuml;hrt werden.',
                info:
                    'Ein virtueller Summenz&auml;hler ist nur m&ouml;glich, wenn alle Z&auml;hler im jeweiligen Geb&auml;ude als intelligente Messsysteme ausgef&uuml;hrt und mit dem Tarifanwendungsfall 7 parametriert sind.',
            },
            physicalSummaryMeter: {
                label:
                    'Die &Uuml;bergabemessung in das Energieversorgungsnetz soll als physischer Summenz&auml;hler ausgef&uuml;hrt werden.',
            },
        },
    },
    meterNumber: {
        label: 'Z&auml;hlernummer',
        summaryLabel: 'Z&auml;hlernummer',
        placeholder: 'Zählernummer',
        info:
            'Die Z&auml;hlernummer finden Sie auf Ihrer Energielieferabrechnung oder auf dem Z&auml;hler. N&auml;here Erl&auml;uterungen finden Sie auch unter <a rel="noopener noreferrer" rel="noopener noreferrer" href="https://www.ewe-netz.de/privatkunden/strom/smart-meter/zaehleranleitungen" target="_blank" title="Zähleranleitungen">Z&auml;hleranleitungen</a>.<br />\r\n<img height="855" alt="Zweirichtungszähler Zählernummer" width="964" src="https://local.deaapi.ewe-netz.de/-/media/dea/bilder/formular/erzeugungsart/zweirichtungszaehler-zaehlernummer.png?la=de-de&amp;cb=656711A7&amp;hash=F3A64883C24FC0E56666DAC7FBE3B1BF" />',
    },
    minorConsumptionAllocation: {
        label:
            'Die geringf&uuml;gigen Verbr&auml;uche der Volleinspeiseanlage sollen gem&auml;ß §10c EEG zu einer vorhandenen weiteren Entnahmestelle zugeordnet werden.',
    },
    noExtraConsumption: {
        label:
            'Auf dem Volleinspeisez&auml;hler darf es keinen zus&auml;tzlichen Verbrauch außer dem Betriebsverbrauch der Solaranlage geben',
    },
    operatorIdentityMatch: {
        label:
            'Der Betreiber der Solaranlage muss Personenidentisch sein mit dem Namen auf dem Stromliefervertrag der weiteren Entnahmestelle.',
    },
    additionalMeterNumber: {
        label: 'Z&auml;hlernummer der weiteren Entnahmestelle (z.B. Haushalt)',
        summaryLabel: 'Z&auml;hlernummer',
        placeholder: 'Zählernummer der weiteren Entnahmestelle (z.B. Haushalt)',
    },
    selfGenerationQuantity: {
        label:
            'Die <strong>Erzeugungs</strong>menge betr&auml;gt pro Jahr voraussichtlich:',
        info:
            'Die erzeugte elektrische Energie in Kilowattstunden einer Stromerzeugungsanlage.',
        unit: 'kWh',
    },
    selfSupplyQuantity: {
        label:
            'Die Eigen<strong>versorgungs</strong>menge in kWh betr&auml;gt pro Jahr voraussichtlich ca.:',
        info:
            'Erzeugte elektrische Energie in Kilowattstunde (kWh), die eine Stromerzeugungsanlage erzeugt und in der Kundenanlage verbraucht wird.',
        unit: 'kWh',
    },
    remainingElectricityInfo: {
        text:
            'Etwaige nach der Eigenversorgung und/oder der Belieferung Dritter verbleibende Strommengen werden in das Netz von EWE NETZ eingespeist.',
    },
};
